import {
  ProductCampaign,
  ProductSocialProofItem,
} from "@/app/lib/features/product/product.types";

/**
 * Get text color style from API color_hex
 * Returns inline style object for dynamic colors from API
 */
export const getSocialProofColorStyle = (
  item: ProductCampaign | ProductSocialProofItem
): React.CSSProperties | undefined => {
  if (item.color_hex) {
    return { color: item.color_hex };
  }
  return undefined;
};

/**
 * Get fallback text color class if color_hex not available
 */
export const getSocialProofColor = (
  item: ProductSocialProofItem
): string => {
  // Fallback colors if color_hex not available
  switch (item.type) {
    case "favorite":
      return "text-red-600";
    case "cart":
      return "text-orange-600";
    case "view":
      return "text-blue-600";
    default:
      return "text-gray-600";
  }
};

/**
 * Get campaign color style from API color_hex
 */
export const getCampaignColorStyle = (
  campaign: ProductCampaign
): React.CSSProperties | undefined => {
  if (campaign.color_hex) {
    return { color: campaign.color_hex };
  }
  return undefined;
};

/**
 * Get fallback campaign color class if color_hex not available
 */
export const getCampaignColor = (campaign: ProductCampaign): string => {
  // API'deki campaign type'lara göre fallback renkler
  switch (campaign.type) {
    case "bulk-percentage":
      return "text-orange-600";
    case "cart-discount":
      return "text-purple-600";
    case "night-deal":
      return "text-indigo-600";
    default:
      return "text-gray-600";
  }
};
